import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import './CompanyTransfer.scss'
import { companyTransferService } from '../../../services/companyTransferService'
import moment from 'moment/moment'

export default function CompanyTransfer() {
  const [transferRequests, setTransferRequests] = useState([])

  useEffect(() => {
    fetchTransferRequests()
  }, [])

  const fetchTransferRequests = async () => {
    const response = await companyTransferService.getCompanyTransferRequests()
    if (response.isOk) {
      setTransferRequests(response.data)
    } else {
      toast.error('Greška pri dohvaćanju kategorija.')
    }
  }

  const handleApproveRequest = async request => {
    const oldUserId = request.company?.user?.id
    const newUserId = request.to_user?.id

    if (!oldUserId || !newUserId) {
      toast.error('Nedostaju podaci o korisniku.')
      return
    }

    const response = await companyTransferService.replaceUserAccount({
      transferRequestId: request.id,
      oldUserId,
      newUserId,
    })

    if (response.isOk) {
      toast.success('Transfer uspješno odobren.')
      setTransferRequests(prev => prev.filter(r => r.id !== request.id))
    }
  }

  const handleRejectRequest = async request => {
    const response = await companyTransferService.rejectCompanyTransfer({
      transferRequestId: request.id,
    })

    if (response.isOk) {
      toast.success('Transfer je odbijen.')
      setTransferRequests(prev => prev.filter(r => r.id !== request.id))
    }
  }

  const renderTransferRequests = () => {
    return transferRequests.map(request => {
      const user = request.to_user || {}

      return (
        <div key={request.id} className="transfer-request">
          <a
            href={`/firma/${request.company?.id}`}
            target="_blank"
            rel="noopener noreferrer">
            {request.company?.name}
          </a>
          <span>{`  (${request.company?.user?.email})`}</span>
          <p className="mt-2">
            {user?.email}
            <br />
            {`${user?.first_name} ${user?.last_name} (${user?.id})`}
            <br />
            {`Datum registracije: ${user?.created_at ? moment(user.created_at).format('DD.MM.YYYY HH:ss') : 'N/A'}`}
          </p>
          <Button
            variant="success"
            onClick={() => handleApproveRequest(request)}>
            Prihvati
          </Button>
          <Button
            variant="danger"
            className="ms-2"
            onClick={() => handleRejectRequest(request)}>
            Odbij
          </Button>
          <hr className="hr divider" />
        </div>
      )
    })
  }

  return (
    <div id="admin-transfers">
      <h1 className="page-title">Transferi</h1>

      <div>{renderTransferRequests()}</div>
    </div>
  )
}
